// extracted by mini-css-extract-plugin
export var buttonsContainer = "roiResults-module--buttonsContainer--8cf46";
export var getStartedButton = "roiResults-module--getStartedButton--0c318";
export var headlineText = "roiResults-module--headlineText--9b542";
export var horizontalLine = "roiResults-module--horizontalLine--40530";
export var invalidRoi = "roiResults-module--invalidRoi--2369e";
export var leftAligned = "roiResults-module--leftAligned--fb730";
export var revenueAmount = "roiResults-module--revenueAmount--82379";
export var revenuePerYear = "roiResults-module--revenuePerYear--5bd16";
export var revenueTotal = "roiResults-module--revenueTotal--64351";
export var roiResultsContainer = "roiResults-module--roiResultsContainer--30530";
export var signupText = "roiResults-module--signupText--e4f53";
export var table = "roiResults-module--table--5aac2";